import { createSelector } from 'reselect';
const promoBasketPopupStateSelector = state => state.promoBasketPopup;
export const makeGetPromoBasketPopupState = () => createSelector(promoBasketPopupStateSelector, (promoBasketPopupState) => promoBasketPopupState);
